import {Base} from "./base";
import dayjs from "dayjs";

class NcpService extends Base {
  constructor() {
    super();
  }

  /**
   * 查询可选项目
   * @param jzkh
   * @param orgid
   * @param isDrugConsult ['1']
   * @returns {Promise<void>}
   */
  async querykdxm({jzkh, orgid, isDrugConsult = undefined}) {
    const {zhizhukdxmxx = []} = await this.$http('zheer.yygh.ApiJyjcService.querykdxm', {
      jzkh, orgid, hosid: orgid, isDrugConsult
    })
    return zhizhukdxmxx;
  }

  /**
   * 开单
   * @param jzkh
   * @param hosid
   * @param allProject
   * @param hzid
   * @param patientSex
   * @param patientName
   * @param patientAge
   * @param hosName
   * @param patId
   * @param binganhao
   * @param isDrugConsult ['1']
   * @param consultId
   * @returns {Promise<void>}
   */
  async openDrug({
                   jzkh,
                   hosid,
                   allProject,
                   hzid,
                   patientName,
                   patientSex,
                   patientAge,
                   hosName,
                   patId,
                   binganhao,
                   consultId = undefined,
                   isDrugConsult = undefined
                 }) {
    const {code} = await this.$http('zheer.yygh.ApiJyjcService.openDrug', {
      jzkh,
      hosid,
      orgid: hosid,
      allProject,
      hzid,
      patientName,
      patientSex,
      patientAge,
      hosName,
      hosId: hosid,
      patId,
      binganhao,
      isDrugConsult,
      consultId
    })
    return code === '0'
  }

  /**
   * 我的订单
   * @param hzid
   * @param hosid
   * @returns {Promise<void>}
   */
  async queryOwnBookHistory({hzid, hosid}) {
    const {list = []} = await this.$http('zheer.yygh.ApiJyjcService.queryOwnBookHistory', {
      hzid, hosid, orgid: hosid
    });
    return list;
  }

  /**
   *
   * @param options
   * @param options.hzid
   * @param options.hosid
   * @returns {Promise<{}>}
   */
  async queryOwnBookCurrent(options) {
    options.orgid = options.hosid;
    const {list = []} = await this.$http('zheer.yygh.ApiJyjcService.queryOwnBookCurrent', options)
    return list;
  }

  /**
   * 我的订单
   * @param hzid
   * @param hosid
   * @param bookId
   * @returns {Promise<void>}
   */
  async queryOwnBookHistoryDetail({hzid, hosid, bookId}) {
    const {list = []} = await this.$http('zheer.yygh.ApiJyjcService.queryOwnBookHistory', {
      hzid, hosid, orgid: hosid
    });

    return list.find(r => {
      return r.bookId == bookId
    });
  }

  /**
   * 我的订单-订单详情
   * @param bookId
   * @param hosid
   * @returns {Promise<void>}
   */
  async queryOwnBookDetail({bookId, hosid}) {
    const {list = []} = await this.$http('zheer.yygh.ApiJyjcService.queryOwnBookDetail', {
      bookId, hosid, orgid: hosid
    });
    return list;
  }

  /**
   * 复诊续方项目
   * @param ysdm
   * @param jzkh
   * @param hosid
   * @param orgid
   * @returns {Promise<void>}
   */
  async querykdxmForConsult({ysdm, jzkh, orgid}) {
    const {zhizhukdxmxx = []} = await this.$http('zheer.yygh.ApiJyjcService.querykdxmForConsult', {
      ysdm, jzkh, hosid: orgid, orgid
    });
    return zhizhukdxmxx;
  }

  /**
   * 复诊续方
   * @param ysdm
   * @param jzkh
   * @param orgid
   * @param consultId
   * @returns {Promise<void>}
   */
  async openDrugForConsult({ysdm, jzkh, orgid, consultId}) {
    const {code = '0'} = await this.$http('zheer.yygh.ApiJyjcService.openDrugForConsult', {
      ysdm, jzkh, hosid: orgid, orgid, consultId
    });
    return code;
  }

  /**
   *
   * @param consultId
   * @param orgid
   * @param jiesuanId
   * @returns {Promise<[]>}
   */
  async queryOrderByConsultId({consultId, orgid, jiesuanId}) {
    const {list = []} = await this.$http('zheer.yygh.ApiJyjcService.queryOrderByConsultId', {
      consultId, orgid, hosid: orgid, jiesuanId
    });
    return list;
  }
}

export const ncpService = new NcpService();



// WEBPACK FOOTER //
// ./src/services/ncp.js